import { defineMessages } from 'react-intl'

const scope = `procurify.components.DataTable.APItemUnitCostCell`

export default defineMessages({
  iconAriaLabel: {
    id: `${scope}.iconAriaLabel`,
    defaultMessage: 'Item unit cost variance warning icon',
  },
})
